module.exports = __webpack_public_path__ + "1f9d004958d10002083a57ed55d26b20.png";